import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';
import type { IProfileData } from '@intigral/types';

export interface ISwitchProfileUseCase {
    execute(
        apiKey: string,
        profileGuid: string,
        currentProfile: IProfileData,
        profilePassword: string,
        token: string,
        identityToken: string
    ): Promise<any>;
}

export class SwitchProfileUseCase implements ISwitchProfileUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        profileGuid: string,
        currentProfile: IProfileData,
        profilePassword: string,
        token: string,
        identityToken: string
    ): Promise<any> {
        const result = await this.profileRepository.switchProfile(
            apiKey,
            profileGuid,
            currentProfile,
            profilePassword,
            token,
            identityToken
        );
        return result.data;
    }
}
